// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__1YeVg","label":"style_label__e2JuL"};